import workspace from "../workspace";
//import Point from "../shapes/point";
import EventManager from "../../store/sqftEventManager";
import sqftConfig, {MIN_DISTANCE_BETWEEN_FREE_DRAW_POINTS} from "../../store/sqftConfig";
import {
  getIntersectCordsBetweenLines,
  getMidPoint,
  getMousePositionOnField,
  getPointDistance,
  getPointOnTheLine, inchesToMm, mmToInches, parseImperialFractionToDecimal,
} from "../../../../helpers/sqftHelper";
import ShapeHelper, {getCountertopPartNames, getLineLengthNumberText} from "../../../../helpers/shapeHelper";
import Config from "../../store/sqftConfig";
import {createShapeFromPoints, createWallFromPointsV2} from "../../../../helpers/freeDrawHelper";
import NumberText from "../workspace/text/numberText";
import store from "../../../../../../store";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import config from "../../store/sqftConfig";
import RenderFreeDraw from "../../helpers/renderFreeDraw";
import COLOR_THEMES, {COLORS} from "../../../../../../colorThemes";
import {FREE_DRAW_TYPE, MEASURE_UNITS, SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../../../constants";
import {getWallLockedPoint, getWallPoint} from "../../helpers/wallHelper";
import {getFreeDrawPoint, getLockedPoint, getLockPointPos} from "../../helpers/freeDrawHelper";
import sqftEventManager from "../../store/sqftEventManager";
import {
  isBackspaceKeyCode,
  isDeleteKeyCode,
  isLengthKeyCode,
} from "../../../../helpers/keyboardHelper";

const FreeDraw = function() {
  let state = {
      isDrawFinished: false,
      addedPoints: [],
      dimensions: [],
      dimensionToMouse: null,
      drawLineToMouse: false,
      lineWidth: 2,
      lineColor: COLOR_THEMES[sqftConfig.activeTheme].primary,
      outlineColor: COLOR_THEMES[sqftConfig.activeTheme].primary,
      minLineLength: 15,
      drawType: FREE_DRAW_TYPE.shape,
      useLockedPoints: true,
      currentNumericInput: "",
      lockedAngleStep: 45
    };

  this.clickedBackSplashButton = null;
  this.arcLength = 0;
  this.angle = 0;
  this.getState = () => state

  const onMouseMove = (mousePos, e) => {
    void e;

    if (state.addedPoints.length > 0) {
      state.drawLineToMouse = true;

      if (!state.dimensionToMouse) {
        this.createDimensionToMouse();
      }
      this.updateMeasurementToMousePosition(mousePos);
    }

    if (state.currentNumericInput.length >= 1 ) {
      state.currentNumericInput = "";
    }
  }

  const onKeyDown = (code, e) => {
    if (window.lineInputFocused) {
      return false;
    }

    if (isLengthKeyCode(e)) {
      const newValue = state.currentNumericInput + e.key;

      if (newValue !== null) {
        state.currentNumericInput = newValue;
        state.dimensionToMouse.value = newValue;
      }
      console.log("currentNumericInput", state.currentNumericInput);
      return true;
    }

    if (isBackspaceKeyCode(e) || isDeleteKeyCode(e)) {
      state.currentNumericInput = state.currentNumericInput.slice(0, -1);
      state.dimensionToMouse.value = sqftConfig.measureUnit === MEASURE_UNITS.Metric
        ? mmToInches(state.currentNumericInput)
        : state.currentNumericInput;
      console.log("currentNumericInput", state.currentNumericInput);
      return true;
    }

    if (code === EventManager.keyCode.ENTER || code === EventManager.keyCode.NumpadEnter) {
      if (state.addedPoints.length > 0 && state.currentNumericInput) {
        this.createPointFromCurrentNumericInput();
      } else {
        state.isDrawFinished = true;
        this.drawFinish();
      }
    }

    return true;
  };

  const onMouseDown = (mousePos) => {
    // var hoverPoint = workspace.getHoverPoint();
    // var hoverShape = workspace.getHoverShape();
    // if (hoverPoint || hoverShape) {
    //   return true;  // return true; // block all mouse-down events // we need dragging workspace
    // }
    state.currentNumericInput = "";
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    //todo pointV2 priority should be higher
    // const hoverPoint = workspace.getHoverPointV2();
    // const wall = WallsManager.getWallByPoint(hoverPoint);
    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
      this.drawWall(mousePos);
      return true;
    }
  };

  const onMouseUp = (mousePos) => {
    void mousePos;

    // this.checkForRestoreCursor();
    //
    // var hoverPoint = workspace.getHoverPoint();
    // var hoverShape = workspace.getHoverShape();
    // if (hoverPoint && !hoverPoint.angleIsChanged) {
    //
    //   if (this.arcLength) {
    //     hoverPoint.arcLength = this.arcLength;
    //     hoverPoint.angle = 0;
    //   } else if (this.angle) {
    //     hoverPoint.angle = this.angle;
    //     hoverPoint.arcLength = 0;
    //   }
    //   return true;
    // } else if (hoverShape) {
    //   Menu.openMenu();
    //   return true;  // if click on shape, block reseting cursor, because we still need it http://jira.mozidev.com/browse/QC-956
    // }/* else {
    //     deregisterEvents();
    //     elements.designDefault.click();
    //   }*/
  };

  this.createPointFromCurrentNumericInput = () => {
    const mousePos = sqftEventManager.getMousePos();
    const lastPoint = state.addedPoints[state.addedPoints.length - 1];
    let distance = parseImperialFractionToDecimal(state.currentNumericInput);
    distance = config.measureUnit === "Imperial" ? distance : mmToInches(distance);
    let newPoint;
    if (state.useLockedPoints && this.isPointExist()) {
      newPoint = getLockedPoint(lastPoint, mousePos, state.lockedAngleStep);
    } else {
      newPoint = getFreeDrawPoint(mousePos);
    }

    //we take full distance and subtract existing point distance from it.
    const segmentLength = getPointDistance(newPoint, lastPoint);
    const newCordsAtDistance = getPointOnTheLine(newPoint, lastPoint, distance - segmentLength);
    newPoint.setPosition(newCordsAtDistance);
    this.drawStart(mousePos, newPoint);
  }

  this.updateMeasurementToMousePosition = (mousePos) => {
    if (state.addedPoints.length > 0) {
      const mPosOnField = getMousePositionOnField(mousePos.x, mousePos.y);
      const lastPoint = state.addedPoints[state.addedPoints.length - 1];
      const distance = getPointDistance(mPosOnField, lastPoint);
      const reduxState = store.getState();
      const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
      const activeButton = reduxState.sqftMenuState.activeButton;
      let midPoint;

      if (isWallsLockMode && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
        const lockedPointPos = getLockPointPos(lastPoint);
        const lockPointOnField = getMousePositionOnField(lockedPointPos.x, lockedPointPos.y);
        midPoint = getMidPoint(lockPointOnField, lastPoint);
        state.dimensionToMouse.pos.betweenPoints.pointTo = lockPointOnField
      } else {
        if (state.useLockedPoints) {
          const lockedPointPos = getLockPointPos(lastPoint, state.lockedAngleStep);
          const lockPointOnField = getMousePositionOnField(lockedPointPos.x, lockedPointPos.y);
          midPoint = getMidPoint(lockPointOnField, lastPoint);
        } else {
          midPoint = getMidPoint(mPosOnField, lastPoint);
        }

        state.dimensionToMouse.pos.betweenPoints.pointTo = getMousePositionOnField(mousePos.x, mousePos.y);
      }
      state.dimensionToMouse.pos.betweenPoints.pointFrom = lastPoint;
      state.dimensionToMouse.pos.x = midPoint.x;
      state.dimensionToMouse.pos.y = midPoint.y;
      state.dimensionToMouse.value = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? inchesToMm(distance) : distance;

      // console.log("state.dimensionToMouse", state.dimensionToMouse);
      // debugger // eslint-disable-line no-debugger
    }
  }

  this.init = function() {
    if (!state.isInited) {
      state.isInited = true;
      this.createDimensionToMouse();
      this.registerEvents();
    }
  };

  this.createDimensionToMouse = () => {
    state.dimensionToMouse = new NumberText(
      0,
      {x: 0, y: 0},
      {shouldRenderFrameBorder: true, isLength: false},
      workspace,
      Function(),
      true
    );
  }

  this.registerEvents = () => {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.SHAPE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      this,
      EventManager.priorities.WALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      this,
      EventManager.priorities.IMAGE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      onMouseUp,
      this,
      EventManager.priorities.OVERALL
    );
    EventManager.addEvent(
      EventManager.events.KEYDOWN,
      onKeyDown,
      this,
      EventManager.priorities.OVERALL
    );
  };

  this.hide = function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  this.deregisterEvents = () => {
    EventManager.resetCursor(this);
    EventManager.removeEvent(this);
    state.isInited = false
  }

  this.destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      EventManager.removeEvent(this, EventManager.events.RENDER);
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
    this.hide();
  };

  const checkIfFirstPointHovered = () => {
    return state.addedPoints.length > 2 && state.addedPoints[0].modelCorePoint.mixins.movable.isHovering();
  }
  // const checkIfLastPointHovered = () => {
  //   return state.addedPoints.length > 2 && state.addedPoints[state.addedPoints.length - 1].modelCorePoint.mixins.movable.isHovering();
  // }
  const checkIfThisIsSecondPoint = () => {
    return state.addedPoints.length === 1;
  }

  this.isPointExist = () => {
    return state.addedPoints.length >= 1;
  }

  this.isFitDistanceWithLastPoint = (point) => {
    if (state.addedPoints.length < 1) {
      return true
    }
    const distance = getPointDistance(point, state.addedPoints[state.addedPoints.length - 1]);

    return distance > MIN_DISTANCE_BETWEEN_FREE_DRAW_POINTS
  }
  this.isMousePosFitDistanceWithLastPoint = (mousePos) => {
    const mousePosOnField = getMousePositionOnField(mousePos.x, mousePos.y);
    return this.isFitDistanceWithLastPoint(mousePosOnField);
  }

  this.initDraw = (useLockedPoints) => {
    state.useLockedPoints = useLockedPoints
  }

  this.drawShape = (mousePos) => {
    if (checkIfFirstPointHovered()) {
      this.drawFinish();
      return;
    }

    if (!state.isDrawFinished && this.isMousePosFitDistanceWithLastPoint(mousePos)) {
      let point;
      if (state.useLockedPoints && this.isPointExist()) {
        const lastPoint = state.addedPoints[state.addedPoints.length - 1];
        point = getLockedPoint(lastPoint, mousePos, state.lockedAngleStep);
      } else {
        point = getFreeDrawPoint(mousePos);
      }

      this.drawStart(mousePos, point);
    }
  }

  this.drawWall = (mousePos) => {
    state.lineWidth = 10;
    state.lineColor = COLORS.gray;
    state.outlineColor = COLORS.gray4;
    state.drawType = FREE_DRAW_TYPE.wall
    if (checkIfThisIsSecondPoint()) {
      const wallPointLocked = getWallLockedPoint(state.addedPoints[0], mousePos, state.lockedAngleStep);
      this.drawStart(mousePos, wallPointLocked);
      this.drawFinish();
    } else {
      const wallPoint = getWallPoint(mousePos);
      this.drawStart(mousePos, wallPoint);
    }
  };

  this.drawStart = (mousePos, pointV2) => {
    if (!state.isDrawFinished && this.isMousePosFitDistanceWithLastPoint(mousePos)) {
      if (state.addedPoints.length > 0) {
        this.addLineDimensions(pointV2);
      }
      state.addedPoints.push(pointV2);
      state.dimensionToMouse ? state.dimensionToMouse.destroy() : null;
      state.dimensionToMouse = null;
    }
  };

  this.addLineDimensions = (pointTo) => {
    //const prevPoint = state.addedPoints[state.addedPoints.length - 2];
    const pointFrom = state.addedPoints[state.addedPoints.length - 1];
    const numberText = getLineLengthNumberText(pointFrom, pointTo, workspace, this.setSegmentLengthFromNumberValue);//new NumberText(thicknessValue, posThickness, {}, this, this.setSegmentThicknessFromNumberValue);

    state.dimensions.push(numberText);
  };

  this.setSegmentLengthFromNumberValue = (value, numberText) => {
    value = Math.round10(+value / Config.getMeasureMultiplier(), -3);
    let miteredSection = numberText.parent;
    let miteredSegments = miteredSection.getSegments();
    let miteredSegment = miteredSegments.find(seg => seg.length === numberText);

    this.setSegmentLength(value, miteredSegment, miteredSection);
  };

  this.resetState = (shouldResetPoints = true) => {
    state.isDrawFinished = false;
    state.currentNumericInput = "";
    if (shouldResetPoints) {
      for (const addedPoint of state.addedPoints) {
        addedPoint.destroy();
      }
    }
    for (const dimension of state.dimensions) {
      dimension.destroy();
    }
    if (state.dimensionToMouse) {
      state.dimensionToMouse.destroy();
    }

    state.addedPoints = [];
    state.dimensions = [];
  };

  this.drawFinish = () => {
    //this.addLineDimensions(state.addedPoints[0], state.addedPoints[1]);
    //const reduxState = store.getState();
    //const activeButton = reduxState.sqftMenuState.activeButton;
    if (state.addedPoints.length > 2 || state.drawType === FREE_DRAW_TYPE.wall && state.addedPoints.length === 2) {
      const shapeCenter = ShapeHelper.getCenterPoint(state.addedPoints);
      let preparedPoints = [];
      switch (state.drawType) {
        case FREE_DRAW_TYPE.wall:
          this.createWall(state.addedPoints, shapeCenter);
          break;
        case FREE_DRAW_TYPE.shape:
          if (state.useLockedPoints) {
            this.changeFirstPointCoordinatesToCreate45or90DegAngleWithTheLastPoint();
          }
          for (const addedPoint of state.addedPoints) {
            addedPoint.x -= shapeCenter.x;
            addedPoint.y -= shapeCenter.y;
            preparedPoints.push(addedPoint);
          }

          this.createShape(preparedPoints, shapeCenter);
          store.dispatch(setSQFTMenuOpened(""));
          store.dispatch(setSQFTActiveButton(""));
          config.workspace.menuItemActive = "";
          this.deregisterEvents();
          break;
      }

      state.dimensionToMouse ? state.dimensionToMouse.destroy() : null;
      state.dimensionToMouse = null;
    }

    this.resetState(!(state.drawType === FREE_DRAW_TYPE.wall));
    // this.deregisterEvents();
    //
    // if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
    //   this.init();
    // }
  };

  this.changeFirstPointCoordinatesToCreate45or90DegAngleWithTheLastPoint = () => {
    if (state.addedPoints.length >= 2) {
      const firstPoint = state.addedPoints[0];
      const secondPoint = state.addedPoints[1];
      const lastPoint = state.addedPoints[state.addedPoints.length - 1];
      //const penultimatePoint = state.addedPoints[state.addedPoints.length - 2];
      const lockPointPos = getLockPointPos(lastPoint, state.lockedAngleStep, firstPoint.getPointField());
      const intersectionPoint = getIntersectCordsBetweenLines(
        firstPoint.getPointField(),
        secondPoint.getPointField(),
        lastPoint.getPointField(),
        lockPointPos,
        true,
        true
      );

      if (intersectionPoint) {
        const intersectionPointOnField = getMousePositionOnField(intersectionPoint.x, intersectionPoint.y);
        state.addedPoints[0].setPosition(intersectionPointOnField);
      }
    }
  }

  this.createShape = (preparedPoints, shapeCenter) => {
    const [countertopPartName] = getCountertopPartNames();
    const shapeId = createShapeFromPoints(
      preparedPoints,
      countertopPartName,
      false,
      shapeCenter,
      true,
      null,
    {},
      {
        minimumShapeArea: 25,
        maximumShapeArea: 100000,
        maximumLineDistance: 1000,
      }
    );
    void shapeId;
  }

  this.createWall = (preparedPoints, centerPoint) => {
    createWallFromPointsV2(preparedPoints, centerPoint, state.lockedAngleStep);
  }

  this.getOffset = function() {
    // //return {x: 0, y: 0};
    // var scale = sqftConfig.scale;
    // var workspacePos = workspace.getOffset();
    // debugger
    // if (parent) {
    //   var _pos = parent.getPosition();
    //   // if (sqftConfig.workspace.snapToGrid){
    //   //   _pos = parent.getSnappedPosition();
    //   // }
    //   var offset = {
    //     x: workspacePos.x + (_pos.x * scale),
    //     y: workspacePos.y + (_pos.y * scale)
    //   }
    // } else {
    //   return {x: 0, y: 0};
    // }
    // return offset;
  };
  this.render = (ctx) => RenderFreeDraw.render(ctx, this.getState())

};

export default new FreeDraw()
